import { Conditions } from '../../rules/Conditions';

// These are the only ones we'll match on.
export function toConditionDisplayName(action: string): string {
  switch (action) {
    case Conditions.Item_Name:
      return 'Product';
    case Conditions.Item_TariffCode:
      return 'Tariff Code';
    case Conditions.Item_Sku:
      return 'SKU';
    case Conditions.Item_MarketplaceService:
      return 'Marketplace Service';
    case Conditions.Item_Source:
      return 'eCommerce Source';
    default:
      return action;
  }
}
